import {
  DynamicBannerConfiguration,
  DynamicBannerContent,
  DynamicBannerStyleProperties
} from '../../../../models';

export interface DynamicBanner {
  content: DynamicBannerContent;
  config: DynamicBannerConfiguration;
  styles: DynamicBannerStyleProperties;
}
